const publishNewsletterSignup = ()=>{
    Shopify.analytics.publish('newsletter_signup', {
        event: 'Newsletter Subscription'
    });
};
const bind = (element)=>{
    const form = element;
    const listId = form.dataset.klaviyoListId;
    const companyId = form.dataset.klaviyoCompanyId;
    if (!listId || !companyId) return;
    form.addEventListener('submit', async (e)=>{
        e.preventDefault();
        const emailInput = form.querySelector('[name="email"]');
        if (!emailInput) return;
        if (!emailInput.checkValidity()) {
            emailInput.reportValidity();
            return;
        }
        const body = JSON.stringify({
            data: {
                type: 'subscription',
                attributes: {
                    profile: {
                        data: {
                            type: 'profile',
                            attributes: {
                                email: emailInput.value
                            }
                        }
                    }
                },
                relationships: {
                    list: {
                        data: {
                            type: 'list',
                            id: listId
                        }
                    }
                }
            }
        });
        try {
            const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    revision: '2024-10-15'
                },
                body
            });
            if (response.ok) {
                form.classList.add('success');
                publishNewsletterSignup();
            }
        } catch  {
        // on network error, silently fail — no native fallback as old endpoint is deprecated
        }
    });
};
export const init = async function() {
    document.querySelectorAll('[data-js-newsletter]').forEach(bind);
};
